// eventEmitter.ts
import { CloudinaryFile } from '../types/cloudinary_custom_types';
import mitt from 'mitt';

// Define your event types
type Events = {
  editSaved: { url: string; id: string };
  editRendering: { originalUrl: string };
  mediaSelected: { content_media: { serialized_file: CloudinaryFile; id: string }[]; body_provisional_id?: string };
  // Add more event types as needed
};

export const eventEmitter = mitt<Events>();
